import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[touchGestures]'
})
export class TouchGesturesDirective {
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() public onWindowResize = new EventEmitter<void>();
	@Output() public swipeLeft = new EventEmitter<void>();
	@Output() public swipeRight = new EventEmitter<void>();

	public touchStartX: number = 0;
	public touchEndX: number = 0;

	@HostListener('window:resize', ['$event'])
	public onResize(event: Event): void {
		this.onWindowResize.emit();
	}

	@HostListener('touchstart', ['$event'])
	public onTouchstart(event: TouchEvent): void {
		this.touchStartX = event.changedTouches[0].screenX;
	}

	@HostListener('touchend', ['$event'])
	public onTouchend(event: TouchEvent): void {
		this.touchEndX = event.changedTouches[0].screenX;
		this.handleGesture();
	}

	public handleGesture(): void {
		if (this.touchEndX < this.touchStartX) {
			this.swipeLeft.emit();
		} else if (this.touchEndX > this.touchStartX) {
			this.swipeRight.emit();
		}
	}
}
